var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import SuccessScoringGroupService from "../../../../Domain/SuccessScoringGroup/SuccessScoringGroup.service";
import ProgressBar from "../../../UI/ProgressBar/ProgressBar";
import BootstrapColorService from "../../../../Services/Shared/BootstrapColor.service";
const getBarColor = (group) => {
    var _a;
    switch ((_a = group === null || group === void 0 ? void 0 : group.rank) === null || _a === void 0 ? void 0 : _a.toString()) {
        case SuccessScoringGroupService.HighId.toString():
            return BootstrapColorService.Danger;
        case SuccessScoringGroupService.MediumId.toString():
            return BootstrapColorService.Warning;
        case SuccessScoringGroupService.LowId.toString():
            return BootstrapColorService.Success;
        default:
            return BootstrapColorService.Secondary;
    }
};
const SuccessBar = (_a) => {
    var { score, scoringGroup, height, showLabel, labelOnLeft, className } = _a, otherProps = __rest(_a, ["score", "scoringGroup", "height", "showLabel", "labelOnLeft", "className"]);
    if (!scoringGroup) {
        return null;
    }
    const label = showLabel && (_jsxs("small", { className: "mx-1", children: [Math.round(score * 100), "%"] }));
    return (_jsxs("div", Object.assign({}, otherProps, { className: "d-flex align-items-center w-100 " + (className || ""), children: [labelOnLeft && label, _jsx(ProgressBar, { height: height, bars: [
                    {
                        progress: score,
                        color: getBarColor(scoringGroup),
                        title: scoringGroup.name,
                    },
                ] }), !labelOnLeft && label] })));
};
export default SuccessBar;
